module.exports = __webpack_public_path__ + "static/media/activate-account-error.7eb109d6.svg";